import { IconButton } from "@circleco/compass/components/IconButton";

import { t } from "@/i18n-js/instance";

import { useCircleAiStore } from "../../useCircleAiStore";

export const RecentChatsToggleButton = () => {
  const isOpen = useCircleAiStore(s => s.isRecentChatsOpen);
  const toggle = useCircleAiStore(s => s.toggleRecentChats);

  const ariaLabel = isOpen
    ? t("circle_ai_home.recent_chats_drawer.close")
    : t("circle_ai_home.recent_chats_drawer.open");

  return (
    <IconButton
      icon="clock-dash"
      variant="ghost"
      onClick={toggle}
      title={ariaLabel}
      aria-label={ariaLabel}
      aria-pressed={isOpen}
      data-popup-open={isOpen || undefined}
    />
  );
};
